//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useContext, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ToastContainer from 'react-bootstrap/ToastContainer';
import Toast from 'react-bootstrap/Toast';

import * as choiceApi from '../../api/choice';
//import { MEMBERSHIP_TYPE_COUPLE } from '../../api/choice';
import { Form, Input, LookupSelect, Label, FormSubmit, Checkbox, FormContext } from '../../common/form-helpers';

import { SITE_KEY } from '../../App';
import './Application.scss';

const blankPerson = {
    firstName: "",
    lastName: "",
    nickname: "",
    genderId: choiceApi.GENDER_NONE,
    birthDate: "",
    country: "US",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    occupation: "",
}

const blankApplication = {
    typeId: choiceApi.MEMBERSHIP_TYPE_COUPLE,
    levelId: choiceApi.MEMBERSHIP_LEVEL_BASIC,
    statusId: choiceApi.MEMBERSHIP_STATUS_NEW,
    organizationId: choiceApi.ORG_ID_CHOICE,
    person: [blankPerson, blankPerson],
    sameAddress: false,
}

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];


const currYear = new Date().getFullYear();
const maxAge = 80;
const yearsLen = maxAge - 18;
const dobYears = Array.from(Array(yearsLen), (x, i) => {
    const year = currYear - 18 - i;
    return { text: `${year}`, value: `${year}` };
});

const dobMonths = Array.from(Array(12), (x, i) => {
    return { text: `${monthNames[i]}`, value: `${i + 1}` }
});

const dobDays = Array.from(Array(31), (x, i) => {
    return { text: `${i + 1}`, value: `${i + 1}` }
});

dobYears.unshift({
    text: "",
    value: "0",
});

dobMonths.unshift({
    text: "",
    value: "0",
});

dobDays.unshift({
    text: "",
    value: "0",
});


const requiredFields = [
    "levelId", "organizationId", "statusId", "typeId"
];

const requiredPersonFields = [ 
    "address", "year", "month", "day", "city", "country", "email", "firstName", "genderId", "lastName", "phone", "state", "zip", "occupation"
]

function isEmpty(field) {
    console.log(field, typeof field)
    if ((field === "") || (field === undefined) || (field === "0")) {
        return true;
    }
    else {
        return false;
    }
}

function validateAppFields(fields) {
    let okay = true;
    
    requiredFields.forEach((element) => {
        if (fields[element] === "") {
            okay = false;
        }
    });

    requiredPersonFields.forEach((element) => {
        if (isEmpty(fields.person[0][element])) {
            // console.log(`didn't like person[0][${element}] = '${fields.person[0][element]}`)
            okay = false;
        }
    });

    if (fields.typeId === choiceApi.MEMBERSHIP_TYPE_COUPLE) {
        requiredPersonFields.forEach((element) => {
            if (isEmpty(fields.person[1][element])) {
                // console.log(`didn't like person[1][${element}] = '${fields.person[1][element]}`)
                okay = false;
            }
        });
    }

    return okay;
}


function AppPerson({
    basePath,
    i,
}) {
    const { current } = useContext(FormContext);
    const { sameAddress } = current;
    const { country } = current.person[i];
    //const [country, setCountry] = useState('US');

    const disabled = (i === 1) && sameAddress;

    const stateEntry = (country === 'US') ?
        <LookupSelect name={`${basePath}/state`} listName="state_code" displayValue disabled={disabled} clearOnDisable /> :
        <Input maxLength="100" name={`${basePath}/state`} disabled={disabled} clearOnDisable />

    return (
        <Row className='g-2'>
            <Col xs={12} className="section-title">
                {i === 0 ? "Tell us about yourself" : "Tell us about your partner"}
            </Col>
            <Col xs={6}>
                <Input name={`${basePath}/firstName`} maxLength="200" />
                <Label name={`${basePath}/firstName`}>First Name</Label>
            </Col>
            <Col xs={6}>
                <Input name={`${basePath}/lastName`} maxLength="200" />
                <Label name={`${basePath}/lastName`}>Last Name</Label>
            </Col>
            <Col xs={6}>
                <Input name={`${basePath}/nickname`} maxLength="200" />
                <Label name={`${basePath}/nickname`}>Nickname/Scene Name</Label>
            </Col>
            <Col xs={6}>
                <LookupSelect name={`${basePath}/genderId`} listName="member_gender" />
                <Label name={`${basePath}/genderId`}>Gender</Label>
            </Col>
            <Col xs={4}>
                <LookupSelect name={`${basePath}/year`} getList={() => dobYears} />
                <Label name={`${basePath}/year`}>Birthdate</Label>
            </Col>
            <Col xs={5}>
                <LookupSelect name={`${basePath}/month`} getList={() => dobMonths} />
                <Label name={`${basePath}/month`}> </Label>
            </Col>
            <Col xs={3}>
                <LookupSelect name={`${basePath}/day`} getList={() => dobDays} />
                <Label name={`${basePath}/day`}> </Label>
            </Col>
            <Col xs={12} lg={6}>
                <Input name={`${basePath}/phone`} type="tel" />
                <Label name={`${basePath}/phone`}>Phone Number</Label>
            </Col>
            <Col xs={12}>
                <Input name={`${basePath}/email`} type="email" />
                <Label name={`${basePath}/email`}>Email</Label>
            </Col>
            <Col xs={12}>
                <Input name={`${basePath}/occupation`} />
                <Label name={`${basePath}/occupation`}>Occupation</Label>
            </Col>
            <Col xs={12} className="section-title">
                {i === 0 ? "Your address" : <div><Checkbox name="/sameAddress" title="Same as address as partner" /></div>}
            </Col>
            <Col xs={12}>
                <LookupSelect name={`${basePath}/country`} listName="country_code" disabled={disabled} clearOnDisable />
                <Label name={`${basePath}/country`}>Country</Label>
            </Col>
            <Col xs={12}>
                <Input name={`${basePath}/address`} maxLength="100" disabled={disabled} clearOnDisable />
                <Label name={`${basePath}/address`}>Address</Label>
            </Col>
            <Col xs={5}>
                <Input name={`${basePath}/city`} maxLength="50" disabled={disabled} clearOnDisable />
                <Label name={`${basePath}/city`}>City</Label>
            </Col>
            <Col xs={3}>
                {stateEntry}
                <Label name={`${basePath}/state`}>State</Label>
            </Col>
            <Col xs={4}>
                <Input name={`${basePath}/zip`} maxLength="10" disabled={disabled} clearOnDisable />
                <Label name={`${basePath}/zip`}>Zip</Label>
            </Col>
        </Row>
    )
}

export function Application(props) {
    const startingApplication = JSON.parse(sessionStorage.getItem('application')) ?? blankApplication;

    const [ , setLoadingRecaptcha ] = useState(false);
    const [ saving, setSaving ] = useState(false);
    const [ showSuccess, setShowSuccess ] = useState(false);
    const [ showError, setShowError ] = useState(false);

    const defaultPersonCount = (startingApplication?.typeId ?? choiceApi.MEMBERSHIP_TYPE_COUPLE) === choiceApi.MEMBERSHIP_TYPE_COUPLE ? 2 : 1;
    const [ personCount, setPersonCount ] = useState(defaultPersonCount);




    
    const onFieldChange = (fields, dirty) => {
        const newPersonCount = fields.typeId === choiceApi.MEMBERSHIP_TYPE_COUPLE ? 2 : 1;
        if (newPersonCount !== personCount) {
            setPersonCount(newPersonCount);
        }

        sessionStorage.setItem('application', JSON.stringify(fields));

    }

    const onSubmit = async (fields) => {
        setSaving(true);
        // console.log("raw fields", fields)
        // merge date of birth fields together
        let person = fields.person.map((x) => ({ 
            ...x, 
            birthDate: `${x.year}-${x.month}-${x.day}`,
            phone: x.phone.replace(/\D/g, '') 
        }))

        if (fields.sameAddress) {
            //console.log("using same address info")
            person[1].country = person[0].country;
            person[1].address = person[0].address;
            person[1].state = person[0].state;
            person[1].city = person[0].city;
            person[1].zip = person[0].zip;
        }
        const newFields = { ...fields, person: person };

        // check to see if all fields are filled in
        if (!validateAppFields(newFields)) {
            alert("All fields must be filled in")
            console.log("MISSING FIELDS", newFields);
            setSaving(false);
            return;
        }

        //console.log('sending application', newFields);

        setLoadingRecaptcha(true);
        window.grecaptcha.ready(async () => {
            try {
                const token = await window.grecaptcha.execute(SITE_KEY, { action: 'submit' });
                const resp = await choiceApi.createApplication(newFields, token);
                //console.log(resp);
                if (resp.success) {
                    sessionStorage.removeItem('application'); //TODO: uncomment this since it should be here - but for testing, it's nice to comment it out
                    setShowSuccess(true);
                }
            }
            catch (error) {
                console.log(error);
                setShowError(true);
            }
            setLoadingRecaptcha(false);
            setSaving(false);
        });
    }


    const displayPerson = Array.apply(null, Array(personCount)).map((x, i) => {
        return(
            <Col xs={12} lg={6} key={`person-${i}`}>
                <AppPerson i={i} basePath={`/person/${i}`} />
            </Col>
        )
    })



    // TODO: create list for application_level that does not inlcude VIP/Unlimited may need to do similar for application_type
    // TODO: update level to use groupId feature
    return (
        <Container className="application">
            <ToastContainer className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
                <Toast show={showSuccess} bg="primary" onClose={() => setShowSuccess(!showSuccess)} delay={10000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Application Received</strong>
                        <small>Just Now</small>
                    </Toast.Header>
                    <Toast.Body>We will get back to you soon!</Toast.Body>
                </Toast>
            </ToastContainer>

            <ToastContainer className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
                <Toast show={showError} bg="danger" onClose={() => setShowError(!showError)} delay={10000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Unable to Process Application</strong>
                        <small>Just Now</small>
                    </Toast.Header>
                    <Toast.Body>Please try again! If you continue to have problems, please contact us.</Toast.Body>
                </Toast>
            </ToastContainer>

            <h1>Join Us</h1>

            <Form className="ifta-form dark" initial={startingApplication} getList={choiceApi.getLookup} onFieldChange={onFieldChange}>
                <Row className='g-2'>
                    <Col xs={12} className="section-title">
                        Which membership are you intersted in?
                    </Col>

                    <Col xs={4}>
                        <LookupSelect name="/organizationId" listName="org_id" />
                        <Label name="/organizationId">Club</Label>
                    </Col>
                    <Col xs={4}>
                        <LookupSelect name="/typeId" listName="membership_type" groupUsing="/organizationId" />
                        <Label name="/typeId">Type</Label>
                    </Col>
                    <Col xs={4}>
                        <LookupSelect name="/levelId" listName="app_level" />
                        <Label name="/levelId">Level</Label>
                    </Col>
                </Row>

                <Row>
                    {displayPerson}
                </Row>

                <Row>
                    <Col xs={{offset: 8, span: 4}} lg={{offset: 10, span: 2}} className="text-end">
                        <FormSubmit disabled={saving} as={Button} onClick={onSubmit} ignoreDirty> 
                            Send
                        </FormSubmit>
                    </Col>
                </Row>
            </Form>

        </Container>
    );
}
